import React, { useEffect } from 'react';
import './PublicInfoPage.css';
import ScrollToTopButton from '../../components/ScrollToTopButton';

const ScopeLimitationsPage = () => {
  useEffect(() => {
    document.title = "Avisa";
  }, []);

  const sections = [
    {
      title: "Scope of the Project",
      content: (
        <>
          <p>
            This study focuses on the design, development, and technical validation of Avisa, an AI-integrated legal information system. It consists of a cross-platform mobile application for citizens and a web-based administrative control center for local officials, built on a Three-Tier Cloud-Native Architecture.
          </p>
          <p>
            Avisa uses Gemini 3.1 Flash Lite to transform unstructured legal documents into structured, bilingual English and Filipino data. The model was selected for its low-cost API rates, native multimodal capabilities, and fast output generation. The pilot covers national mother laws connected to local ordinances within one selected LGU and three pilot barangays for hyper-local ordinance mapping.
          </p>
          <p>
            The system includes a Context-Augmented Generation chat interface, role-based access control, real-time monitoring of national laws, and expert validation of AI-generated summaries. Barangay document representatives receive scoped view, edit, and upload privileges supported by audit logging, two-step validation, and appointment-based activation.
          </p>
          <p>
            The project also includes LGU onboarding through landing-page submissions and administrator-approved municipal account provisioning for multi-tenant scalability. Its credit-based model provides five free daily credits, reset at midnight PHT; text queries use one credit and image queries use three credits, with PayMongo and webhook-based balance updates supporting paid usage.
          </p>
        </>
      )
    },
    {
      title: "Delimitations and Limitations",
      content: (
        <>
          <p>
            Manual data gathering and encoding are limited to one selected LGU, three selected pilot barangays within that municipality, and the mother laws connected to their local ordinances. The system supports future expansion through its multi-tenant architecture, but the following are outside this study:
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '12px', marginBottom: '16px', color: '#475569', lineHeight: 1.7 }}>
            <li style={{ marginBottom: '8px' }}>Manual gathering, scanning, and verification for non-pilot barangays or complete municipality-wide ordinance collections.</li>
            <li style={{ marginBottom: '8px' }}>Municipality-wide automated ordinance ingestion and verification.</li>
            <li style={{ marginBottom: '8px' }}>Official legal advice, legal filings, or replacement of formal legal processes and official acts of local legislatures.</li>
            <li style={{ marginBottom: '8px' }}>Offline AI operation, because Gemini API and Firebase Cloud services require internet connectivity.</li>
            <li style={{ marginBottom: '8px' }}>Public access to the administrative web application, which is restricted to authorized administrative users.</li>
          </ul>
          <p>
            Avisa is strictly an informational tool. AI-generated interpretations and plain-language summaries do not constitute legal advice. Legal experts will review outputs for accuracy, completeness, and safety, and their findings will guide further refinement before wider rollout.
          </p>
        </>
      )
    }
  ];

  return (
    <div className="pip-root">
      <main className="pip-container">
        <div className="pip-card">
          <div className="pip-content-header">
            <h1 className="pip-title">Scope &amp; Limitations</h1>
            <p className="pip-subtitle">Project coverage and defined boundaries</p>
          </div>

          <div className="pip-content-body">
            {sections.map((section, index) => (
              <section key={index} className="pip-section">
                <div className="pip-section-header">
                  <span className="pip-section-number">{(index + 1).toString().padStart(2, '0')}</span>
                  <h3>{section.title}</h3>
                </div>
                <div>{section.content}</div>
              </section>
            ))}

            <footer className="pip-footer">
              <p>© 2026 Avisa. All rights reserved.</p>
            </footer>
          </div>
        </div>
      </main>
      <ScrollToTopButton />
    </div>
  );
};

export default ScopeLimitationsPage;
